<div class="card">
  <div class="card-header">
    <span class="card-title">{{ shieldingId ? "Edit" : "Add" }} {{ itemTypeName }}</span>
  </div>
  <div class="card-body">
    <mat-form-field *ngIf="!isShieldingNote">
      <mat-label>Shielding Name</mat-label>
      <input
        matInput
        [(ngModel)]="shieldingName"
        type="text"
        placeholder="Shielding Name"
        [disabled]="loading"
        [matAutocomplete]="auto"
        (keyup)="filter($event)"
        [ngModelOptions]="{ standalone: true }"
      />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option
          *ngFor="let shielding of shieldingsFiltered"
          [value]="shielding.name"
          [disabled]="isAlreadyAdded(shielding)"
          (onSelectionChange)="getInfoShielding(shielding)"
        >
          {{ shielding.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="no-subscript">
      <mat-label>{{ isShieldingNote ? "Note" : "KE Text" }}</mat-label>
      <textarea
        matInput
        [(ngModel)]="shieldingKeText"
        rows="5"
        [placeholder]="isShieldingNote ? 'Note' : 'KE Text'"
        [disabled]="loading"
        [ngModelOptions]="{ standalone: true }"
      ></textarea>
    </mat-form-field>

    <div *ngIf="!isShieldingNote">
      <app-resource-link-relation
        [dialogTitle]="'Windchill Links'"
        [componentTitle]="'Windchill Links'"
        [typeLink]="5"
        [links]="inputData.resource.windchillLinks ?? []"
        [resourceId]="inputData.resource.id"
        [isEdition]="true"
        [disabled]="loading"
        (changed)="linkChanged()"
      >
      </app-resource-link-relation>
    </div>

  </div>

  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button mat-flat-button color="warn" (click)="cancel()">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="isSaving"
        (click)="add()"
      >
        Accept
      </button>
    </div>
  </div>
</div>
